module.exports = __webpack_public_path__ + "static/img/ADAM-SWEID.3a74b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ADAM-SWEID.jpg
// module id = Baqd
// module chunks = 0